import{format as r}from"date-fns";import t from"react";import{Box as e}from"../Box/Box.js";function o(o){var m=o.date,y=o.showTime;return t.createElement(e,null,r(m,y?"MMM dd, yyyy h:mm:A":"MMM dd, yyyy"))}export{o as default};
//# sourceMappingURL=DateCell.js.map
